


















import Vue from 'vue'

/* Wrapper class for multi selects */
export default Vue.extend({
  name: 'MultiSelect',

  props: {
    value: {
      type: Array as () => any[],
      default: [] as any[],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
    popperClass: {
      type: String,
      default: '',
    },
    collapseTags: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    internalValue: {
      get(): any {
        return this.value
      },
      set(value: any): any {
        this.$emit('input', value)
      },
    },
  },
})
